import type {Field} from "./Field.js";

/**
 * Constraint position only. {@link Field} is invariant in its value type, so a constraint
 * written with `unknown` would exclude every concrete field.
 */
export type AnyField = Field<any, boolean>;

/** A model's fields, keyed by property name. */
export type FieldMap = Record<string, AnyField>;

/** A relation the payload identified by id only. The model resolves it on demand. */
export interface EntityRef {
    readonly id: number;
}

export const isEntityRef = (value: unknown): value is EntityRef =>
    typeof value === "object" && value !== null && typeof (value as EntityRef).id === "number";

export type JsonValue = string | number | boolean | null | JsonValue[] | { [key: string]: JsonValue };
export type JsonObject = { [key: string]: JsonValue };

export const isJsonObject = (value: JsonValue | undefined): value is JsonObject =>
    typeof value === "object" && value !== null && !Array.isArray(value);
